<script>
export default {
  name: "ManualLookupDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ""
    },
    rows: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "update:keyword", "search", "select", "close"],
  watch: {
    modelValue(isOpen) {
      if (!isOpen) return
      this.$nextTick(() => {
        const target = this.$refs.manualLookupInputRef
        if (target && typeof target.focus === "function") {
          target.focus()
        }
      })
    }
  },
  methods: {
    onClose() {
      this.$emit("update:modelValue", false)
      this.$emit("close")
    },
    onKeywordInput(value) {
      this.$emit("update:keyword", value)
    },
    onSearch() {
      this.$emit("search")
    },
    onSelect(row) {
      this.$emit("select", row)
    }
  }
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" @hide="onClose">
    <q-card class="manual-lookup-modal">
      <q-card-section class="row items-center q-pb-sm">
        <div class="text-h6">수동 조회</div>
        <q-space />
        <q-btn flat round dense icon="close" v-close-popup />
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-input
          ref="manualLookupInputRef"
          :model-value="keyword"
          clearable
          label="오더번호 / HBL / 고객명 / 바코드 검색"
          @update:model-value="onKeywordInput"
          @keyup.enter="onSearch"
        >
          <template v-slot:append>
            <q-btn
              color="primary"
              label="검색"
              :loading="loading"
              @click="onSearch"
            />
          </template>
        </q-input>
      </q-card-section>

      <q-card-section v-if="loading" class="q-pt-none text-center">
        <q-spinner color="primary" size="28px" />
        <div class="text-caption text-grey-7 q-mt-xs">수동조회 목록 불러오는 중...</div>
      </q-card-section>

      <q-card-section v-else class="q-pt-none">
        <q-markup-table flat bordered>
          <thead>
            <tr>
              <th class="text-left">오더번호</th>
              <th class="text-left">HBL</th>
              <th class="text-left">고객명</th>
              <th class="text-left">목적지</th>
              <th class="text-left">첫 바코드</th>
              <th class="text-left">생성시각</th>
              <th class="text-center">선택</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.orderNo">
              <td>{{ row.orderNo }}</td>
              <td>{{ row.hblNo }}</td>
              <td>{{ row.customerName }}</td>
              <td>{{ row.destination }}</td>
              <td>{{ row.firstBarcode }}</td>
              <td>{{ row.createdAt }}</td>
              <td class="text-center">
                <q-btn
                  dense
                  color="primary"
                  label="선택"
                  @click="onSelect(row)"
                />
              </td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="7" class="text-center text-grey-7">
                조회 결과가 없습니다.
              </td>
            </tr>
          </tbody>
        </q-markup-table>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.manual-lookup-modal {
  width: 980px;
  max-width: 95vw;
}
</style>
